import HomeScorecardCard from "./homeScorecardCard";
import PopUpScorecardCollaborate from "../../../../popUpForms/popUpScorecardFormCollaborate";

const CardScorecardCollaborateWithUs = ({
  hoveredTab,
  onTabHover,
  onTabLeave,
}) => {
  return (
    <HomeScorecardCard
      hoveredTab={hoveredTab}
      onTabHover={onTabHover}
      onTabLeave={onTabLeave}
      id="scorecard-collab"
      title="Collaborate With Us"
      titleColor="var(--orange)"
      image="./images/home/card-collaborate-with-us.jpg"
      caption="Successful community pilot gathering in Aldercroft Heights with partners from the Santa Clara County FireSafe Council, CAL FIRE, Guidewire, Black Swan Analytics, and CWPC. The team is strategizing options to overcome owner's locked gates to ensure safe alternative emergency evacuation."
      popUpComponent={<PopUpScorecardCollaborate />}
      content={[
        {
          type: "paragraph",
          color: "var(--white)",
          text: "The global rollout kicks off with a pilot program enabling communities worldwide to test and refine the Wildfire Resilience Scorecard.",
        },
        {
          type: "paragraph",
          color: "var(--white)",
          text: "Pilot the Scorecard! <br /> Multi-stakeholder collaboration is critical for preventing catastrophic wildfires.",
        },
        { type: "button", color: "var(--orange)", text: "Collaborate with Us" },
      ]}
    />
  );
};

export default CardScorecardCollaborateWithUs;
